import React from "react";
import { Avatar } from "@mui/material";
import { Groups, Tag } from "@mui/icons-material";
import User from "../../models/User";
import { ChatConversation } from "../../models/Chat";
import { avatarColor, directPartnerId, userDisplayName, userInitials } from "./chatUtils";

interface ChatAvatarProps {
  user?: User | null;
  size?: number;
}

const ChatAvatar: React.FC<ChatAvatarProps> = ({ user, size = 32 }) => (
  <Avatar
    title={userDisplayName(user)}
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.4,
      fontWeight: 600,
      bgcolor: avatarColor(user?.id ?? 0),
    }}
  >
    {userInitials(user)}
  </Avatar>
);

export const ConversationAvatar: React.FC<{
  conversation: ChatConversation;
  meId: number;
  usersById: Map<number, User>;
  size?: number;
}> = ({ conversation, meId, usersById, size = 32 }) => {
  if (conversation.type === "direct") {
    const partner = directPartnerId(conversation, meId) ?? meId;
    return <ChatAvatar user={usersById.get(partner)} size={size} />;
  }
  return (
    <Avatar
      variant={conversation.type === "channel" ? "rounded" : "circular"}
      sx={{
        width: size,
        height: size,
        bgcolor: avatarColor(conversation.id + 3),
      }}
    >
      {conversation.type === "channel" ? (
        <Tag sx={{ fontSize: size * 0.6 }} />
      ) : (
        <Groups sx={{ fontSize: size * 0.6 }} />
      )}
    </Avatar>
  );
};

export default ChatAvatar;
